var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 26,
    height: 1,
    viewBox: "0 0 26 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 788739543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 1353",
    d: "M26 0.5L0 0.5",
    stroke: "#C7CBD7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepDivider);
export default __webpack_public_path__ + "static/media/step-divider.fc83f49747911bd641d7da8c024be546.svg";
export { ForwardRef as ReactComponent };